/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'checkbox',
  templateUrl: './checkbox.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => {
        return CheckboxComponent;
      }),
      multi: true,
    },
  ],
})
export class CheckboxComponent implements ControlValueAccessor {
  @Input() checkedValue: any = true;
  @Input() uncheckedValue: any = false;
  @Input() disabled = false;
  @Input() class = '';
  @Input() labelBaseClass = 'checkbox';
  @Input() inputClass = '';
  @Input() isRequired = false;

  value = false;

  onChange?: any;
  onTouched?: any;

  writeValue(value: any) {
    this.value = value == this.checkedValue;

    if (!this.value && value != this.uncheckedValue) {
      setTimeout(() => {
        this.onValueChanged();
      });
    }
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
  }
  //#endregion

  onValueChanged() {
    this.onChange(this.value ? this.checkedValue : this.uncheckedValue);
  }
}
